import { debounce } from 'lodash'
export const myMixin = {
  data () {
    return {
      maxheight: 'auto',
      isFiltration: false,
      currentRow: null,
      paginationOptions: {
        Page: 1,
        total: 0,
        PageSize: 40,
      },
    }
  },
  created () { },
  mounted () {
    this.handleResize = debounce(this.handleResize, 200) // 设置防抖延迟为200毫秒
    window.addEventListener('resize', this.handleResize)
    this.setTableMaxHeight()
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    downFile (par) {
      this.$newsApi.common.getUrlPath().then(res => {
        if (res.data.Resultcode == 0) {
          let path = res.data.data
          let paths = path + par
          window.open(paths)
        }
      })
    },
    setTableMaxHeight () {
      this.$nextTick(() => {
        this.maxheight = this.$setTableMaxHeight('.app-main-content', '.content-head')
      })
    },
    handleInput (value, obj, key) {
      console.log(value, key)
      // 只允许输入数字和小数点，并且小数点不能作为第一位
      const cleanedValue = value.replace(/[^\d.]/g, '') // 移除非数字和小数点的字符
      const regex = /^\d*\.?\d*$/
      if (regex.test(cleanedValue)) {
        if (cleanedValue.startsWith(".")) {
          // 小数点不能是第一位，自动添加0在前面
          this[obj][key] = "0" + cleanedValue
        } else {
          this[obj][key] = cleanedValue
        }
      }
    },
    handleResize () {
      this.setTableMaxHeight()
    },
    //展开收起
    setFiltration () {
      this.isFiltration = !this.isFiltration
      this.setTableMaxHeight()
    },
    // 单选表格：行样式
    tableRowClassName ({ row }) {
      if (this.currentRow && this.currentRow === row) {
        return 'current-row'
      }
      // 尝试通过常见主键匹配保持跨页/重渲染高亮
      const primaryKeys = ['ID', 'Orders_ID', 'SPCApply_ID', 'Transfer_ID']
      if (this.currentRow) {
        for (const key of primaryKeys) {
          if (this.currentRow[key] !== undefined && row[key] !== undefined && this.currentRow[key] === row[key]) {
            return 'current-row'
          }
        }
      }
      return ''
    },
    // 单选表格：点击行选中
    handleRowClick (row) {
      this.currentRow = row
    },

    /*
      点击行选中
      */
    handleRowMultipleClick(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    /*
    表格行类名
    */
    tableRowMultipleClassName({ row }) {
      if (this.multipleSelection.some(item => item.Orders_ID === row.Orders_ID)) {
        return "multiple-selection-row";
      }
      return "";
    },
  }
}
